/* eslint-disable */

export function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + (date.toUTCString());
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; domain=' + (window.location.host);
}

export function getCookie(name) {
    var reg = new RegExp(('(^| )' + name + '=([^;]*)(;|$)'));
    var arr = document.cookie.match(reg);
    if (arr) {
        return unescape(arr[2]);
    }
    return null;
}

var blockList = ['/request_demo', '/updatePassword', '/login.html', '/'];

export function setLastPage(_url) {
    var url = _url || window.location.href;
    if (blockList.indexOf(window.location.pathname) < 0) {
        setCookie('lastPage', url, 0.1);
    }
}

const commonInitCookie_umd = {
    blockList: blockList,
    setCookie: setCookie,
    getCookie: getCookie,
    setLastPage: setLastPage
};

export default commonInitCookie_umd;

if (window.initCookieUtils) {
    // script标签上则直接执行setPage
    window.initCookieUtils.setLastPage();
}
